module.exports = __webpack_public_path__ + "img/bg.8d36db7d.png";